module.exports = __webpack_public_path__ + "img/people-tab2.56ee0a5f.png";